import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import { handlePostRequest } from "../../../services/PostTemplate";
import { handlePutRequest } from "../../../services/PutTemplate";
import { useDispatch, useSelector } from "react-redux";
import { SetEditCompanyUsersFlagAction, SetCompanyUsersFormDataToNullAction, GetCompanyUsersDetailsAction } from "../../../redux/actions/companyAction";
import * as Yup from "yup";
import ZbizInput from "../../../components/zbizInput/ZbizInput";
import ZDropdown from "../../../components/zDropdown/ZDropdown";
import EnableorDisableUser from "./EnableorDisableUser";
import { useHistory } from "react-router-dom";

function AddEditCompanyUsers({ companyId, editable }) {
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("pi pi-save");
    const dispatch = useDispatch();
    const history = useHistory();

    const editFlag__Store = useSelector((state) => state.companySlice?.companyUsersEditFlag);
    const formData__Store = useSelector((state) => state.companySlice?.companyUsersFormData);

    const validationSchema = Yup.object().shape({
        contactNo: Yup.string().required("This field is required.").matches(/^03\d{9}$/, 'Contact number must start with "03" and be exactly 11 digits.'),
        designation: Yup.string().max(50, "Maximum length 50 allowed").required("This field is required."),
        email: Yup.string().email("Invalid email address format").required("This field is required."),
        roleId: Yup.mixed().required("This field is required."),
        // userName: Yup.string().max(100, "Maximum length 100 allowed").required("This field is required."),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            contactNo: "",
            designation: "",
            email: "",
            employeeNo: "",
            userName: "",
            roleId: "",
        },
        onSubmit: async (data) => {
            try {
                setloading(true);
                setloadingIcon("pi pi-spin pi-spinner");

                data["userName"] = formik.values.email
                if (editFlag__Store) {
                    data["userId"] = formData__Store?.userId;
                    const res = await handlePutRequest(data, "zbizgateway/nonFin/updateCompanyUser");

                    if (res?.status === 400) {
                        res?.data.forEach((element) => {
                            formik.setFieldError(element?.field, element?.message);
                        });
                    } else {
                        dispatch(SetEditCompanyUsersFlagAction(false));
                        dispatch(SetCompanyUsersFormDataToNullAction());
                    }
                } else {
                    data["companyId"] = companyId;
                    const res = await handlePostRequest(data, "zbizgateway/nonFin/saveCompanyUser");

                    if (res?.status === 400) {
                        res?.data.forEach((element) => {
                            formik.setFieldError(element?.field, element?.message);
                        });
                    } else {
                        formik.resetForm();
                    }
                }
                getCompanyUsersDetail();
            } catch (error) {
                console.error("An error occurred:", error);
            } finally {
                setloading(false);
                setloadingIcon("pi pi-save");
            }
        },
    });
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    const props = { onChange: formik.handleChange, values: formik.values, isFormFieldValid: isFormFieldValid, getFormErrorMessage: getFormErrorMessage };

    useEffect(() => {
        if (editFlag__Store) {
            fillCompanyUserForm()
        }
    }, [editFlag__Store, formData__Store]);

    const handleCancel = (e) => {
        e.preventDefault();
        formik.resetForm();
        dispatch(SetEditCompanyUsersFlagAction(false));
        dispatch(SetCompanyUsersFormDataToNullAction());
    };

    const getCompanyUsersDetail = async () => {
        await dispatch(GetCompanyUsersDetailsAction("zbizgateway/nonFin/getUser/" + companyId));
    };

    const fillCompanyUserForm = () => {
        if (formData__Store) {
            Object.keys(formData__Store).forEach((key) => {
                if (formik.initialValues.hasOwnProperty(key)) {
                    formik.setFieldValue(key, formData__Store[key]?.toString());
                }
            });
            formik.setFieldValue("roleId", formData__Store?.tblUserRoles?.[0]?.tblRole?.roleId?.toString());
        }
    };

    useEffect(() => {
        formik.setFieldValue("contactNo", "")
        formik.setFieldValue("designation", "")
        formik.setFieldValue("email", "")
        formik.setFieldValue("roleId", "")
        formik.setFieldValue("parserHeadId", "")
    }, []);

    return (
        <div>
            <div className="page_header">
                <div className="Top__Btn" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div className="d_align">
                        <i className="pi pi-arrow-circle-left mr-1" onClick={() => history.goBack()} />
                        <h3 className="mod_heading">Authorized Company Users</h3>
                    </div>
                </div>
            </div>
            <div className="card Card__Round">
                <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2 pos_relative">
                    <div className="p-fluid p-formgrid p-grid">
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field input_cp">
                                <ZbizInput label="Contact Number" required keyName="contactNo" placeholder="03XXXXXXXXX" keyfilter={/^[0-9]+$/} {...props} />
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field input_cp">
                                <ZbizInput label="Designation" required keyName="designation" placeholder="Enter Designation" {...props} keyfilter={/^[a-zA-Z\s]+$/} />
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field input_cp">
                                <ZbizInput label="Email" required keyName="email" placeholder="Enter Email" {...props} />
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field input_cp">
                                <ZbizInput label="Employee Number" keyName="employeeNo" placeholder="Enter Employee Number" {...props} type="number" />
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field input_cp">
                                {/* <ZbizInput label="User Name" required keyName="userName" placeholder="Enter User Name" {...props} keyfilter={/^[a-zA-Z0-9]+$/} /> */}
                                <ZbizInput label="User Name" required keyName="email" {...props} disabled />
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field input_cp">
                                <ZDropdown {...props} label="User Role" required valueOption="id" keyName="roleId" placeholder="Select Role" optionLabel="description" url="zbizgateway/lov/lovRole" />
                            </div>
                        </div>
                    </div>
                    {
                        editable === "view" ? (<div className="overlay_field"></div>) : ""
                    }
                    {editable === "true" ? (
                        <div className="GenerateDown__Btn p-mt-4">
                            <EnableorDisableUser handleCancel={handleCancel} getCompanyUsersDetail={getCompanyUsersDetail} />
                            <Button className="Btn__Transparent" label={editFlag__Store ? "Update" : "Add"} disabled={loading || editFlag__Store} type="submit" />
                            <Button className="Btn__Dark" label="Cancel" onClick={(e) => handleCancel(e)} type="button" />
                        </div>
                    ) : null}
                </form>
            </div>
        </div>
    );
}

export default AddEditCompanyUsers;
